import { createRoute } from "@tanstack/react-router";
import { VersionsTable } from "@/components/case/versions-table";
import { useCaseDetail } from "@/hooks/use-case-detail";
import { caseLayoutRoute } from "./case-layout-route";

export const caseVersionsRoute = createRoute({
  getParentRoute: () => caseLayoutRoute,
  path: "/versions",
  component: CaseVersionsPage,
});

function CaseVersionsPage() {
  const { caseId } = caseVersionsRoute.useParams();
  const detailQuery = useCaseDetail(caseId);

  if (!detailQuery.data) return null;

  return <VersionsTable caseId={caseId} detail={detailQuery.data} />;
}
